import React, { useState, useMemo, useEffect } from 'react';
import {
  getStoryblokApi,
} from '@storyblok/react';
import Container from 'react-bootstrap/Container';
import ErrorBoundary from '../../components/ErrorBoundary';
import EmptyResult from '../../components/EmptyResult';
import FilteredContext from '../../contexts/FilteredContext';
import TTCContainer from '../TTCContainer';
import i18next from '../../translations/i18n';

/* For dev tests */
/* window.ttCentre = {
  isoCode: 'it-IT',
  origin: 'https://sitecore10prod.wisdomtree.eu',
};
 */
const TacticalTradingApp = () => {
  const storyblokApi = getStoryblokApi();

  const [filters, setFilters] = useState([]);
  const [storiesList, setStories] = useState([]);
  const filterList = useMemo(() => ({ filters, setFilters }), []);
  const siteCoreLang = (window.ttCentre && window.ttCentre.isoCode) || 'en-GB';

  const language = {
    'en-gb': 'en-gb',
    'de-de': 'de-de',
    'en-us': 'en-us',
    'it-it': 'it',
    'fr-fr': 'fr-fr',
  };

  useEffect(() => {
    const getStories = async () => {
      const { data: {
        stories,
      } } = await storyblokApi.get('cdn/stories', {
        version: process.env.REACT_APP_NODE_ENV === 'development' ? 'draft' : 'published',
        language: language[siteCoreLang.toLowerCase()] || '',
        fallback_lang: 'default',
      });

      setStories(stories.map((story, idx) => ({
        ...story.content,
        _uid: story.content._uid + idx,
      })));
      return stories;
    };
    getStories();
  }, []);

  if (!storiesList || storiesList.length === 0) {
    return <EmptyResult message={i18next.t('NoPostToDisplay')} />;
  }

  return (
    <FilteredContext.Provider value={filterList}>
      <ErrorBoundary>
        <Container fluid className="">
          <TTCContainer stories={storiesList} />
        </Container>
      </ErrorBoundary>
    </FilteredContext.Provider>
  );
};
export default TacticalTradingApp;
